import { useEffect, useState } from 'react';
import Button from '../Button/Button';
import '../../components/InternalHalfPageBriefs/InternalHalfPageBriefs.css'
import { Globals as OldGlobals } from '../../global/Globals';
import { fetchHalfPageBreif, fetchByfilter, fetchChannelsByClusterID } from '../../services/api';
import { formatDate, getFieldKeys } from '../../util/util';
import { fetchFilterByCretedBy, getShelveBriefStatus } from "../../services/dashboardAPI";
import { useNavigate } from 'react-router-dom';
import NoResultsComponent from '../NoResults/NoResult';
import Loader from '../Loader/Loader';
import DropdownList from '../DropdownList/DropdownList';
import { setSelectedtableitem } from '../../pages/Login/LoginSlice';
import { useDispatch } from 'react-redux';
import CryptoUtils from '../../util/cryptoUtils';
import DownloadDocPdf from '../../components/DownloadDocPdf/DownloadDocPdf';
import { useLanguage } from '../../context/Languagecontext';

export default function InternalHalfPageBreif({ additionalData, togglePopup, item, onClose, popupShow,isAudiTrail=false }) {
  const { Globals } = useLanguage();
  const navigate = useNavigate();
  const [BreifData, setBreifData] = useState([])
  const [clusterList, setClustersList] = useState()
  const [channelList, setChannelList] = useState()
  const [isShelveStatus, setIsShelveStatus] = useState();

  const [contentData, setContentData] = useState([])
  const [contentDataStatus, setContentDataStatus] = useState(null)
  const [data, setData] = useState([]);
  const proposalId = item.proposalId;
  const dispatch = useDispatch();
  const payload = { selectedTableItem: item.bRefNo };
  const proposalStatus = item?.proposalStatus?.statusName;
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId").toString());
  const [cluster, setCluster] = useState([]);
  const [channelsArray, setChannelsArray] = useState([]);
  const [selectedClusterID, setSelectedCLusterID] = useState("");
  const [selectedChannelID, setSelectedChannelID] = useState("");
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedClusterName, setSelectedClusterName] = useState("");


  const [smName, setSMName] = useState('');

  const clusterValue = BreifData[9];
  const channelName = BreifData[2];
  const [hideMainLayout, setHideMainLayout] = useState(false);
  const [hidehalfscreen, sethideHalfscreen] = useState(false);
  const [isClusterChannelVisible, setClusterChannelVisible] = useState(false);
  const [halfPageData, setHalfPageData] = useState();
  const [popUpState, setPopUpState] = useState({
    open: false,
    title: '',
    text: '',
    negativeAction: null,
    normalAction: null,
    negativeActionText: '',
    normalActionText: '',
  });
  const [clusterError, setErrorCluster] = useState({ error: '', msg: '' });
  const [channelError, setChannelError] = useState({ error: '', msg: '' });
  const proposalBody = { proposalDetailId: 0, status: 0, proposalId: proposalId?.toString() }
  const reAssignBriefBody = { proposalDetailId: 0, proposalId: proposalId?.toString(), clusterId: selectedClusterID, channelId: selectedChannelID }
  const [isReAssignBtnDisabled, setReAssignBtnDisabled] = useState(true);
  const [btnClassName, setBtnClassName] = useState('disabled-apply-btn');
   const multiLang = localStorage.getItem("lang");

  const getData = async () => {
    try {
      const result = await fetchHalfPageBreif(
        OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
        proposalId
      );

      const {
        createdByName,
        countryName,
        productionTypeName,
        channelName,
        formatName,
        languageName,
        genreName,
        contentTypeName,
        clusterName,
        description,
        submissionRequirements,
        evalAndSelection,
        closingDate,
        region,
        commisioningEditors,
        briefTypeName,
        ceEvalDeadline,
        smEvalDeadline,
        producers
      } = result.content;
      setHalfPageData(result.content);
      setContentData([
        { Description: description },
        { "Submission Requirements": submissionRequirements },
        { "Evaluation Process": evalAndSelection },
      ]);
      const ceJoints = commisioningEditors.join(", ");
      setBreifData([
        { name: "Created By", description: createdByName },
        { name: "Closing Date", description: (closingDate === OldGlobals.DEFAULT_MIN_DATE ? Globals.NA : formatDate(closingDate)) },
        { name: "Channel", description: channelName },
        { name: "Format", description: formatName },
        { name: "Country", description: countryName },
        { name: "Production Type", description: productionTypeName },
        { name: "Scripted / \n Non-Scripted", description: contentTypeName },
        { name: "Genre", description: genreName },
        { name: "Language", description: languageName },
        { name: "Cluster", description: clusterName },
        { name: "Commissioning \n Editiors", description: ceJoints },
        { name: "Brief Type", description: briefTypeName },
        { name: "CE Evaluation Deadline", description: formatDate(ceEvalDeadline) },
        { name: "SM Evaluation Deadline", description: formatDate(smEvalDeadline) },
        { name: "Producers", description: producers.join(", ") }
      ])
      setData([result?.content]);

    } catch (error) {
      setContentDataStatus("Error");
      console.error('Error in App component:', error);
    }
  };

  const getClustersData = async () => {
    try {
      const result = await fetchByfilter(
        "Clusters"
      );
      setClustersList(result.data.content.Clusters);



    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
    }
  }


  const getSMDetails = async (clusterId) => {
    try {
      const clusterId = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))[0].clusterId;
      const response = await fetchFilterByCretedBy(Globals.HALF_PAGE_BRIEF_DETAILS.SM_ROLE_ID, clusterId);
      const name = response?.data?.content?.map(item => item.name).join(", ") || " ";
      setSMName(name.trim());
    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
      setSMName(" ");
      console.error('Error in App component:', error);
    }
  }
  const handleClustersList = (event) => {
    const clusterId = clusterList.find(item => item.name === event).id;
    setSelectedCLusterID(clusterId);
    setSelectedClusterName(event)
    clusterError.error = false;
    clusterError.msg = "";
    setErrorCluster(clusterError)
    setSelectedChannelID('');
    setReAssignBtnDisabled(true)
    getChannelsList(clusterId);
    getSMDetails(clusterId)
    setBtnClassName("disabled-apply-btn")

  }

  const getShelveStatus = async () =>{
    try{
      const result = await getShelveBriefStatus(proposalId)
      if(result.data.status === 'OK'){
        setIsShelveStatus(true)
      }else{
        setIsShelveStatus(false)
      }
    }catch(error){
      setIsShelveStatus(false)
    }
  }


  useEffect(() => {
    getData();
    getClustersData();
  }, []);

  useEffect(() => {
    (proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.ACTIVE ||
      proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.SUBMISSIONS_CLOSED ||
      proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.IN_REVIEW ||
      proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.GREEN_LIT) &&
      getShelveStatus();
  }, [proposalStatus]);

  const handleBackPress = () => {
    setHideMainLayout(false)
    setClusterChannelVisible(false);
    setSelectedCLusterID('');
    setSelectedChannelID('');
    setBtnClassName("disabled-apply-btn")
    setReAssignBtnDisabled(true)
  }
  const getChannelsList = async (clusterId) => {
    try {
      const result = await fetchChannelsByClusterID(
        clusterId
      );
      setChannelList(result.data.content);
      if (result.data.content.length > 0) {
        setClusterChannelVisible(true);
      }


    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
      console.error('Error in App component:', error);
    }
  }
  useEffect(() => {
    if (clusterList?.length > 0) {
      const arry = clusterList?.map((item) => item.name);

      setCluster(arry);
    }

     if (channelList?.length) {
      const arry = channelList
        .filter((item) =>
          selectedClusterName ===   halfPageData.clusterName   //checking same clusterid selcted or not
            ? item.channelName !== halfPageData.channelName   //removing same channel from list if user selected same cluster
            : true
        )
        .map((item) => item.channelName);
      setChannelsArray(arry);
    }
  }, [clusterList, channelList]);

  const handleReload = () => {
    setContentDataStatus(null)
    getData();
  }

  const fetchSMDetails = async () => {
    try {
      const clusterId = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))[0].clusterId;
      const response = await fetchFilterByCretedBy(Globals.HALF_PAGE_BRIEF_DETAILS.SM_ROLE_ID, clusterId);
      const name = response?.data?.content?.map(item => item.name).join(", ") || " ";
      return name;
    } catch (error) {
      console.error("Error fetching SM Details:", error);
      const name = " ";
      return name;
    }
  };

  const handleChannelList = (event) => {
    const channelId = channelList.find(item => item.channelName === event).channelId;
    setSelectedChannelID(channelId);
    setSelectedChannelName(event);
    channelError.error = false;
    channelError.msg = "";
    setChannelError(channelError)
    setReAssignBtnDisabled(false)
    setBtnClassName("reassign-btn-active")

  }
  const [activeIndexes, setActiveIndexes] = useState({});

  const handleToggle = (category, index) => {
    setActiveIndexes(prevState => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [index]: !prevState[category]?.[index]
      }
    }));
  };



  const gotoHome = (success = false) => {
    if (success) {
      navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "dashboard" } })
      return;
    }
    navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "dashboard" } })
  }

  const openPopUp = (popUpType = "Submit", updateFlag = false) => {
    if (popUpType === "Submit") {
      if (selectedClusterID === '') {
        const newClusterError = { ...clusterError, error: true, msg: Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER_ERROR };
        setErrorCluster(newClusterError);
      } else if (selectedChannelID === '') {
        const newChannelError = { ...channelError, error: true, msg: Globals.HALF_PAGE_BRIEF_DETAILS.CHANNEL_ERROR };
        setChannelError(newChannelError);
      }  else {

        sethideHalfscreen(true);
        onClose()
        popupShow({
          open: true,
          title: Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_BRIEF,
          promptText: Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_POP_UP_DESC1 + smName + Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_POP_UP_DESC2,
          isTextBox: true,
          customClassName: "Re-Assign-Brief-pop-up",
          normalActionText: Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_BRIEF,
          textAreaStyle: 'CommentsInputStyle',
          textAreaTitle: Globals.HALF_PAGE_BRIEF_DETAILS.COMMENTS,
          toastMessage: Globals.HALF_PAGE_BRIEF_DETAILS.REASSIGN_BRIEF_TOAST_SUCCESS,
          limit: Globals.TXT_AREA_MAX_CHARS_LIMIT,
          body: reAssignBriefBody
        })
      }
      return;
    }
  };
  return (
    <div>
      {/* Main Half Screen */}
      {!hideMainLayout ?
        <div className="Half-Page-Content">
          <div className="Half-Page-Header-Wrapper">
            {data && data?.length > 0 &&
              <div className='Half-page-breif-header'>{`${data?.[0]?.bRefNo} ${" "} ${data?.[0]?.channelName} ${data?.[0]?.countryName} - ${data?.[0]?.formatName}`}</div>

            }
            <span className="HalfPage-close-icon HalfPage-close-icon-brief" onClick={onClose}>
              &times;
            </span>

          </div>
          {data && data?.length > 0 ? <>{
             <div className='intenalhalf-page-brief'>
               <div className='Download-Wrapper-Brief'>
              <DownloadDocPdf proposalDetailId={null} proposalId={data[0]?.proposalId} proposalType={"Briefs"} proposalTitle={data[0]?.bRefNo} />
            </div>
            
            <div className="HalfPage-pitch1">

              <div key={0} className="Half-Page-Content-Wrapper">
                <div className="Half-Page-Desc-header">
                  {Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}
                </div>
              </div>
              { }
              {contentData?.map(
                (item, index) =>
                  Object.values(item)[0] && (
                    <div key={index} className="Half-Page-Content-Wrapper">
                      <div className="Half-Page-Desc-header-layout">
                        {/* {Object.keys(item)[0]} */}
                        {Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                        {/* {getFieldKeys(Globals.SOLICITED_BRIEF, Object.keys(item)[0])} */}
                      </div>
                      <p className="Half-Page-Description">
                        {Object.values(item)[0]}
                      </p>
                    </div>
                  )
              )}
              <div>
                <div className="Half-Page-Form">
                  {BreifData?.map((item, index) => (
                    <div key={index} className="Half-Page-Form-Fields" >
                      <div className="Half-Page-Form-fields-Bold" style={{ whiteSpace: 'pre-line' }}>
                        {Globals.BRIEF_DATA_KEYS[`${item.name.toUpperCase()}`]}
                      </div>
                      <div className="Half-Page-Form-Description">
                        {item.description?item.description:'N/A'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
           </div>
          }
          
            {(roleID !== "2" && roleID !=="6") ? 
                <div className="Half-Page-Close-Apply-Wrapper">
                
                  <div className="Half-Page-Close-Apply-btn-Brief">
                    {/* Buttons visibility based on the status */}
                    <div className="Half-Page-Close-Apply-btn-layout">
                    <Button
                        title={Globals.HALF_PAGE_BRIEF_DETAILS.CLOSE}
                        id="Half-Screen-Close-Btn"
                        additionalStyle="close-text"
                        action={onClose}
                      />
                    </div>
                      {/* Buttons for DRAFT Status */}
                    {proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.DRAFT ?
                      <div className="Half-Page-Close-Apply-btn-Brief">
                      <Button
                        title={Globals.HALF_PAGE_BRIEF_DETAILS.EDIT_BUTTON_TEXT}
                        id="half-page-cc-send-mail-btn"
                        additionalStyle="half-page-cc-send-mail-btn"
                        onClick={onClose}
                        action={() =>navigate(`/editnewbrief/${data[0].proposalId}`, { state: { activeData: data }})}
                      />
                      </div>
                      :
                      (proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.ACTIVE || proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.SUBMISSIONS_CLOSED || proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.IN_REVIEW || proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.GREEN_LIT || proposalStatus ===Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.EXPIRED) ?
                      <div className="Half-Page-Close-Apply-btn-Brief">
                      
                        {proposalStatus !== Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.EXPIRED && !isShelveStatus && (
                      
                      <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_BRIEF}
                          id="Half-Screen-Shelve-Button1"
                          additionalStyle={`apply-button applybtn-${multiLang}`}
                          action={async () => {
                            onClose()
                            const smRoleName = await fetchSMDetails();
                            if (smRoleName) {
                              popupShow({
                                open: true,
                                title: Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_BRIEF1,
                                promptText: Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_POP_UP_DESC1 + smRoleName,
                                isTextBox: true,
                                customClassName: 'brief-popup-content',
                                normalActionText: Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_BRIEF1,
                                textAreaStyle: 'popup-shelve-text',
                                textAreaTitle: Globals.HALF_PAGE_BRIEF_DETAILS.COMMENTS,
                                toastMessage: Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_BRIEF_TOAST_SUCCESS,
                                body: { ...proposalBody, status: Globals.STATUS_NUMBER.SEVEN }
                              })
                            }
                          }}
                        />)}
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_BRIEF_BTN_TEXT}
                          id="Half-Screen-Re-Assign-Buttons"
                          additionalStyle={`re-assign-button reassing-${multiLang}`}
                          onClick={onClose}
                          item={item}
                          action={() => { setHideMainLayout(true) }}
                          proposalIds={proposalId}
                        />
                        {!isAudiTrail && (
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.VIEW_PROPOSALS}
                          id="Half-Screen-View-Proposal-Button1"
                          additionalStyle="apply-button"
                          action={() => {
                            onClose();
                            dispatch(setSelectedtableitem(payload));
                            navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals" } });
                          }}
                        />
                        )}
                      </div> :

                      //Buttons for Shelved Status , shelved requested and reassign requested
                      <div className="Half-Page-Close-Apply-btn-Brief">
                        {proposalStatus === Globals.HALF_PAGE_BRIEF_DETAILS.STATUS.SHELVED && <><Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.REACTIVATE_BRIEF}
                          id="Half-Screen-Reactivate-Button1"
                          additionalStyle="apply-button"
                          action={() => {
                            onClose()
                            popupShow({
                              open: true,
                              title: Globals.HALF_PAGE_BRIEF_DETAILS.ACTIVATE_BRIEF,
                              promptText: Globals.HALF_PAGE_BRIEF_DETAILS.REACTIVATE_POP_UP_DESC,
                              isTextBox: false,
                              customClassName: 'brief-popup-content',
                              normalActionText: Globals.HALF_PAGE_BRIEF_DETAILS.ACTIVATE_BRIEF,
                              textAreaStyle: 'popup-email-text',
                              textAreaTitle: Globals.HALF_PAGE_BRIEF_DETAILS.COMMENTS,
                              toastMessage: Globals.HALF_PAGE_BRIEF_DETAILS.REACTIVATE_BRIEF_TOAST_SUCCESS,
                              body: { ...proposalBody, status: Globals.STATUS_NUMBER.ZERO }
                            })
                          }}
                        />
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_BRIEF_BTN_TEXT}
                          id="Half-Screen-Re-Assign-Buttons"
                          additionalStyle={`re-assign-button reassing-${multiLang}`}
                          onClick={onClose}
                          item={item}
                          action={() => { setHideMainLayout(true) }}
                          proposalIds={proposalId}
                        /></>}
                        {!isAudiTrail && (
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.VIEW_PROPOSALS}
                          id="Half-Screen-View-Proposal-Button1"
                          additionalStyle="apply-button"
                          action={() => {
                            onClose();
                            dispatch(setSelectedtableitem(payload));
                            navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals" } });
                          }}
                      
                        />
                        )}
                      </div>
                  }

                </div>
              </div> : 
              <div className="Half-Page-Close-Apply-Wrapper">
                  <div className="Half-Page-Close-Apply-btn-Brief1">
                  
                  <div className="Half-Page-Close-Apply-btn-layout1">
                  
                    <Button
                        title={Globals.HALF_PAGE_BRIEF_DETAILS.CLOSE}
                        id="Half-Screen-Close-Btn"
                        additionalStyle="close-text"
                        action={onClose}
                      />
                    </div>
                    {!isAudiTrail && (
                    <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.VIEW_PROPOSALS}
                          id="Half-Screen-View-Proposal-Button1"
                          additionalStyle="apply-button"
                          action={() => {
                            onClose();
                            dispatch(setSelectedtableitem(payload));
                            navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "all_proposals" } });
                          }}
                        />
                        )}
                  </div>
                  </div>
            }
          </> : contentDataStatus && contentDataStatus?.length > 0 ? <>
          <div className='intenalhalf-page-brief'>
            <div className="No-Results-Wrapper"><NoResultsComponent
              data={{
                message: Globals.HALF_PAGE_MESSAGE,
                img: OldGlobals.IMG.HALF_PAGE_ERROR,
                submessage: OldGlobals.HALF_PAGE_SUB_MESSAGE,
                className: "ErrorHeader",
                subclassName: "SubError",
                outerWrapper: "HalfPageWrapperHalfPageBrief",
                imgWrapper: "HalfPageBriefImg",
                button: 'reload'
              }}
              handleReload={handleReload}
            />
            </div>
          
          </div>
          

            <div className="Half-Page-Close-Apply-Wrapper">
              <div className="Half-Page-Close-Apply-btn-Brief">
                <div className="Half-Page-Close-Text-Brief" onClick={onClose}>
                  {Globals.CLOSE}
                </div>
              </div>
            </div>
          </> : <div className="NoResultsComponent" style={{ height: "80vh" }}>
            <Loader height={50} width={50} />
          </div>}

        </div>


        // {/* Hidden Page for Re-Assign page */}

        : (

          !hidehalfscreen &&
          <div>
            <div className="Half-Page-Content">
              <div className="Half-Page-Header-Wrapper">
                <div id="hp_brief_back_arrow" className="hp_brief_back_arrow"><img className="cross-mark" src={OldGlobals.IMG.LEFT_ARROW} alt="close" onClick={handleBackPress} /></div>

                {data && data?.length > 0 &&
                  <div className='Half-page-breif-header'>{`${data?.[0]?.bRefNo} ${" "} ${data?.[0]?.channelName} ${data?.[0]?.countryName} - ${data?.[0]?.formatName}`}</div>
                }
                <span className="HalfPage-close-icon HalfPage-close-icon-brief" onClick={onClose}>
                  &times;
                </span>

              </div>

              {data && data?.length > 0 ? <>
                <div className='intenalhalf-page-brief'>
                <div className="HalfPage-pitch1" key={0}>
                  <div
                    draggable
                    onDragStart={(e) => e.preventDefault()}
                    onClick={() => handleToggle("brief-details", 0)}
                  >
                
                      <div class="brief-expandable-header-layout">
                      <p className="brief-accordion-label">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</p>

                    <img
                      src={activeIndexes["brief-details"]?.[0] ? OldGlobals.IMG.ARROW_UP : OldGlobals.IMG.ARROW_DOWN}
                      alt="toggle icon"
                    
                    />
                    </div>
              
                  </div>
                  {activeIndexes["brief-details"]?.[0] && (
                    <div>

                      { }
                      {contentData?.map(
                        (item, index) =>
                          Object.values(item)[0] && (
                            <div key={index} className="Half-Page-Content-Wrapper">
                              <div className={`${Object.keys(item)[0] === 'Description' ? 'description-heading-layout' : 'small-heading'} Half-Page-Desc-header`}>
                                {Object.keys(item)[0]}
                              </div>
                              <p className="Half-Page-Description">
                                {Object.values(item)[0]}
                              </p>
                            </div>
                          )
                      )}
                      <div>
                        <div className="Half-Page-Form">
                          {BreifData?.map((item, index) => (
                            <div key={index} className="Half-Page-Form-Fields">
                              <div className="Half-Page-Form-fields-Bold" style={{ whiteSpace: 'pre-line' }} >
                                {item.name}
                              </div>
                              <div className="Half-Page-Form-Description">
                                {item.description}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                </div>

                {/* Cluster portion */}
                <div className="HalfPage-pitch1">
                  <div key={0} className="Half-Page-Content-Wrapper">
                    <div className="Half-Page-Desc-header">
                      {Globals.HALF_PAGE_BRIEF_DETAILS.CURRENT_CLUSTER}
                    </div>
                  </div>

                  <div>
                    <div className="Half-Page-Form">

                      <div key={0} className="Half-Page-Form-Fields">

                        <div className="Half-Page-Form-fields-Bold">
                          {Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER}
                        </div>
                        <div className="Half-Page-Form-Description">
                          {clusterValue.description}
                        </div>

                      </div>
                      <div key={1} className="Half-Page-Form-Fields">

                        <div className="Half-Page-Form-fields-Bold">
                          {Globals.HALF_PAGE_BRIEF_DETAILS.CHANNEL}
                        </div>
                        <div className="Half-Page-Form-Description">
                          {channelName.description}
                        </div>

                      </div>

                    </div>

                  </div>

                </div>

                <div className="HalfPage-pitch1">
                  <div key={0} className="Half-Page-Content-Wrapper">
                    <div className="Half-Page-Desc-header">
                      {Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_TO_NEW_CLUSTER}
                    </div>
                  </div>
                  { }

                  <div>
                    <div className="Half-Page-Form-Cluster-Layout">

                      <div key={0} className="Half-Page-Form-Fields">

                        <div className="Half-Page-Form-fields-Bold">
                          <div className='half-Page-clsuter-title-style'>
                            {Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                            <div id="row-content" className="Half-page-cluster-dropdown-layout">
                              <div id="cluster-holder">

                                <span tabIndex={7}><DropdownList options={cluster} onSelect={handleClustersList} placeHolderValue={Globals.HALF_PAGE_BRIEF_DETAILS.SELECT_CLUSTER} selectClass={true && "hightlight" && "dropdown_internal_halfscreen"} /></span>
                                {clusterError.error && <div><img src={OldGlobals.IMG.ERROR} alt="password error" /><span className="invalidDataError">{clusterError.msg}</span></div>}

                              </div>

                            </div>
                          </div>
                          {hideMainLayout && isClusterChannelVisible ?
                            <div className='title-style'>
                              {Globals.HALF_PAGE_BRIEF_DETAILS.CHANNEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                              <div id="row-content" className="Half-page-cluster-dropdown-layout">
                                <div id="cluster-holder">
                                  <span tabIndex={8}><DropdownList valueToReset={cluster} options={channelsArray} onSelect={handleChannelList} placeHolderValue={Globals.HALF_PAGE_BRIEF_DETAILS.SELECT_CHANNEL} selectClass={true && "hightlight" && "dropdown_internal_halfscreen"} /></span>

                                </div>

                              </div>
                            </div>
                            : <></>}
                        </div>


                      </div>

                    </div>
                  </div>
                </div>
                </div>



                {


                  roleID === "5" ?
                    <div className="Half-Page-Close-Apply-Wrapper">
                      <div className="Half-Page-Close-Apply-btn-Brief">
                        <div className="Half-Page-Close-Text-Brief" onClick={onClose}>
                          {Globals.CLOSE}
                        </div>
                        <Button
                          title="Apply"
                          id="Half-Screen-Apply-Button"
                          additionalStyle="apply-button"
                          action={() => navigate(OldGlobals.NAVPATH.APPLY_BRIEF, { state: { activeData: data } })}
                        />
                      </div>
                    </div>
                    :

                    <div className="Half-Page-Close-Apply-Wrapper">
                      <div className="Half-Page-Close-Apply-btn-Brief">
                        <div className="Half-Page-Close-Text-Brief" onClick={onClose}>
                          {Globals.HALF_PAGE_BRIEF_DETAILS.CANCEL}

                        </div>
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_BRIEF_BTN_TEXT}
                          id="Half-Screen-diable-Proposal-Button1"
                          additionalStyle={btnClassName}
                          disable={isReAssignBtnDisabled}
                          onClick={() => openPopUp("Submit")}
                          action={() => openPopUp("Submit")}
                        />
                      </div>
                    </div>


                }
              </> : contentDataStatus && contentDataStatus?.length > 0 ? <>
                <div className="No-Results-Wrapper"><NoResultsComponent
                  data={{
                    message: Globals.HALF_PAGE_MESSAGE,
                    img: OldGlobals.IMG.HALF_PAGE_ERROR,
                    submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                    className: "ErrorHeader",
                    subclassName: "SubError",
                    outerWrapper: "HalfPageWrapperHalfPageBrief",
                    imgWrapper: "HalfPageBriefImg",
                    button: 'reload'
                  }}
                  handleReload={handleReload}
                />
                </div>
                <div className="Half-Page-Close-Apply-Wrapper">
                  <div className="Half-Page-Close-Apply-btn-Brief">
                    <div className="Half-Page-Close-Text-Brief" onClick={onClose}>
                      {Globals.CLOSE}
                    </div>
                  </div>
                </div>
              </> : <div className="NoResultsComponent" style={{ height: "80vh" }}>
                <Loader height={50} width={50} />
              </div>}

            </div>
          </div>
        )
      }

    </div>
  );
}